export default {
  AUDIO_RATE: 44_100,
  AWS_SHORTCUT: { key: ' ', ctrlKey: true }
} as const